import { ChangeEvent, ClipboardEvent, FocusEvent, FormEvent, KeyboardEvent } from "react";

// Blocks manual typing in a DatePicker's text field while leaving the
// calendar popup fully interactive - the user can only set a value by
// picking a day from the calendar. Mirrors the same block
// CustomDateRangePicker.tsx applies to its range-picker field. Pair with
// `enableAccessibleFieldDOMStructure={false}` on the DatePicker so it
// renders a plain single <input> these handlers can target - the default
// sectioned field doesn't route through slotProps.textField.inputProps the
// same way, and DatePicker's own top-level `readOnly` prop would also
// disable clicking days in the calendar, which we don't want.
export const readOnlyDateInputProps = {
  readOnly: true,
  onKeyDown: (event: KeyboardEvent) => event.preventDefault(),
  onKeyUp: (event: KeyboardEvent) => event.preventDefault(),
  onInput: (event: FormEvent) => event.preventDefault(),
  onBeforeInput: (event: FormEvent) => event.preventDefault(),
  onPaste: (event: ClipboardEvent) => event.preventDefault(),
  onCut: (event: ClipboardEvent) => event.preventDefault(),
  onChange: (event: ChangeEvent) => event.preventDefault(),
  onFocus: (event: FocusEvent<HTMLInputElement>) => event.target.blur(),
  style: {
    pointerEvents: "none",
    caretColor: "transparent",
    userSelect: "none",
    WebkitUserSelect: "none",
    MozUserSelect: "none",
    cursor: "default",
  },
} as any;

export const readOnlyDateInputSx = {
  "& .MuiInputBase-root": { cursor: "default !important" },
  "& .MuiInputBase-input": {
    pointerEvents: "none !important",
    caretColor: "transparent !important",
    userSelect: "none !important",
    WebkitUserSelect: "none !important",
    MozUserSelect: "none !important",
  },
  "& .MuiIconButton-root": {
    pointerEvents: "auto !important",
    cursor: "pointer !important",
  },
};
